import { defaultMeta } from '@/constants/defaultMeta';
import { parseDateRangeSearch } from '@/lib/parseDateRange';
import { sortBy } from '@/lib/sortBy';
import { PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { pointConfigurationQueries } from '@/services/pointConfiguration/pointConfiguration.queries';
import { PointConfigurationData } from '@/services/pointConfiguration/pointConfiguration.types';
import { useSearch } from '@tanstack/react-router';
import { getEncryptedPointAgentType, PointAgentTab } from '../pointConfiguration.constants';

const usePointCategories = (type: PointAgentTab, enabled: boolean) => {
  const search = useSearch({ from: '/(app)/points-management/points-configuration/' });
  const dates = parseDateRangeSearch(search.createdDate, { start: 0, end: 0 });
  const params = {
    agentType: getEncryptedPointAgentType(type),
    row: search.page,
    fetch: search.fetch,
    search: search.q ?? '',
    fromDate: dates?.start ?? 0,
    toDate: dates?.end ?? 0,
  };
  const { data, isLoading } = useQuery<PaginatedApiResponse<PointConfigurationData[]>>({
    ...pointConfigurationQueries.list(params),
    enabled,
    select: (res) => ({ ...res, data: sortBy(res.data, search.sort) }),
  });
  return { categories: data?.data ?? [], isLoading, meta: data?.meta?.pagination ?? defaultMeta };
};

export const useAffiliateCategory = (enabled: boolean) => {
  const result = usePointCategories('affiliate', enabled);
  return { affiliateCategories: result.categories, ...result };
};
export const useClubCategory = (enabled: boolean) => {
  const result = usePointCategories('club', enabled);
  return { clubcategories: result.categories, ...result };
};
export const useCustomerCategory = (enabled: boolean) => {
  const result = usePointCategories('customer', enabled);
  return { customercategories: result.categories, ...result };
};
